module.exports = __webpack_public_path__ + "img/microaa.237a400d.png";